var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoVolumeFull = function SvgVideoVolumeFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.167 2.5a.5.5 0 0 0-.77-.421L4.395 4.64a.17.17 0 0 1-.09.027H2.333c-.644 0-1.166.522-1.166 1.166v4.334c0 .644.522 1.166 1.166 1.166h1.972q.049 0 .09.027l4.002 2.561a.5.5 0 0 0 .77-.421zM12.979 2.814a.5.5 0 0 1 .707 0A7.3 7.3 0 0 1 15.833 8a7.3 7.3 0 0 1-2.149 5.185.5.5 0 1 1-.707-.707A6.3 6.3 0 0 0 14.835 8a6.3 6.3 0 0 0-1.855-4.478.5.5 0 0 1 0-.708M11.446 5.054a.5.5 0 0 0-.707.707c.574.574.928 1.365.928 2.24 0 .874-.354 1.665-.928 2.238a.5.5 0 0 0 .707.707A4.16 4.16 0 0 0 12.666 8c0-1.15-.466-2.193-1.22-2.946"
  })));
};
export default SvgVideoVolumeFull;